import { useQuery } from '@tanstack/react-query';
import { getTransactionDetails } from '@dealstack/frontend/app/services/Transactions.service.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const useTransactionDetailsController = (transactionId?: string) => {
	const getTransactionDetailsRequest = useQuery({
		queryKey: [API_PATHS.CAP_TRANSACTION_TRANSACTION_DETAILS_POST, transactionId],
		queryFn: () => getTransactionDetails({ id: transactionId! }),
		enabled: !!transactionId,
	});

	const refetchTransactionDetails = () => getTransactionDetailsRequest.refetch();

	const isTransactionLoading = getTransactionDetailsRequest.isFetching;

	return {
		getTransactionDetailsRequest,
		refetchTransactionDetails,
		isTransactionLoading,
	};
};
